import { render } from "./GroupReportParametres.vue?vue&type=template&id=35a2f3c8"
import script from "./GroupReportParametres.vue?vue&type=script&lang=js"
export * from "./GroupReportParametres.vue?vue&type=script&lang=js"

import "./GroupReportParametres.vue?vue&type=style&index=0&id=35a2f3c8&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__